<template>
  <OArticleCard v-bind="$attrs" class="sm:rounded-md bg-white w-full">
    <template #desktop>
      <OArticleVariant name="cards_10" class="flex">
        <OArticleCover width="273" class="flex-shrink-0 rounded-l-md" :hp4u-attrs="hp4uAttrs" />
        <OArticleBadge pin="left" :hp4u-attrs="hp4uAttrs" />
        <div class="px-4 py-5 flex flex-col w-full">
          <div class="flex-grow">
            <OArticleTitle class="text-lg font-semibold leading-22 hover:text-link-primary line-clamp-4" :hp4u-attrs="hp4uAttrs" />
          </div>
          <div class="mt-1 flex">
            <OArticleHashtag truncate class="mr-auto z-2" />
            <OArticleCategory class="ml-auto z-2" :hp4u-attrs="hp4uAttrs" />
          </div>
        </div>
      </OArticleVariant>
      <OArticleVariant name="cards_6" class="flex flex-col h-full">
        <OArticleCover width="350" class="rounded-t-md" />
        <OArticleBadge pin="left" />
        <div class="p-4 flex flex-col flex-grow">
          <div class="flex-grow">
            <OArticleTitle class="text-xl font-semibold leading-22 hover:text-link-primary line-clamp-3" />
          </div>
          <div class="mt-1 flex">
            <OArticleHashtag class="mr-auto z-2" />
            <OArticleCategory class="ml-auto z-2" />
          </div>
        </div>
      </OArticleVariant>
    </template>
    <template #mobile>
      <OArticleVariant name="big">
        <OArticleCover :hp4u-attrs="hp4uAttrs" />
        <OArticleBadge pin="left" :hp4u-attrs="hp4uAttrs" />
        <div class="p-4 flex flex-col">
          <OArticleTitle class="text-lg leading-22 hover:text-link-primary line-clamp-3" :hp4u-attrs="hp4uAttrs" />
          <div class="mt-1 flex items-center">
            <OArticleHashtag class="mr-auto z-2 leading-22" />
            <OArticleCategory class="ml-auto z-2 leading-22" :hp4u-attrs="hp4uAttrs" />
          </div>
        </div>
      </OArticleVariant>
      <OArticleVariant name="small" class="flex">
        <OArticleBadge pin="right" :hp4u-attrs="hp4uAttrs" />
        <div class="px-4 py-2 flex flex-col flex-grow justify-center">
          <OArticleHashtag class="z-2 leading-22" />
          <div class="">
            <OArticleTitle class="text-13 leading-18 hover:text-link-primary line-clamp-3" :hp4u-attrs="hp4uAttrs" />
          </div>
          <div class="flex items-center">
            <OArticleCategory class="z-2 leading-22" :hp4u-attrs="hp4uAttrs" />
          </div>
        </div>
        <OArticleCover width="190" class="flex-shrink-0" :hp4u-attrs="hp4uAttrs" />
      </OArticleVariant>
    </template>
  </OArticleCard>
</template>
<script>
import OArticleCard from '@/modules/card/components/ArticleCard';
import OArticleCover from '@/modules/card/components/ArticleCover';
import OArticleBadge from '@/modules/card/components/ArticleBadge';
import OArticleTitle from '@/modules/card/components/ArticleTitle';
import OArticleHashtag from '@/modules/card/components/ArticleHashtag';
import OArticleCategory from '@/modules/card/components/ArticleCategory';
import OArticleVariant from '~/modules/card/components/ArticleVariant';
export default {
  components: {
    OArticleCard,
    OArticleCover,
    OArticleBadge,
    OArticleTitle,
    OArticleHashtag,
    OArticleCategory,
    OArticleVariant,
  },
  inheritAttrs: false,
  props: {
    hp4uAttrs: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
